<template>
    <ENB_Extend_Validity>
        <b-row>
            <b-col md="12" class="mt-3">
                <div>
                    <b-row>
                        <b-col md="4">
                            <b-form-group >
                                <b-form-textarea v-model="searching" style="height:100px" ></b-form-textarea>                                       
                            </b-form-group>                                
                        </b-col>

                        <b-col md="2">
                            <b-button :disabled="searching.length == 0" @click="searchEBN_extendValidity()"  size="md" variant="primary">Search</b-button>
                            &nbsp;
                            <b-button :disabled="searching.length == 0" @click="clearEBN_extendValidity()" size="md" variant="danger">Clear</b-button>
                        </b-col>   
                        
                        <b-col md="6">
                            <div class="text-right">
                                <b-button v-if="totalRows>0"  @click="downloadEBN_extendValidity()" size="md" variant="primary">Download</b-button>
                            </div>
                            <br>
                            <div class="text-right">
                                <b-button  @click="getExtension_history()" size="md" variant="primary">Extension History</b-button>
                            </div>
                        </b-col>               
                    </b-row> 
                </div>
                <div>
                    <b-row>
                        <b-col md="2" v-if="CheckLoadID.length>0">
                            <b-button :disabled="isReadOnly" @click="extendValidity()" size="md" variant="primary">Extend EBN Validity</b-button>
                        </b-col>
                    </b-row>
                </div>

                <div class="mt-2">
                    <b-row>
                        <b-col md="4">
                            <div v-if="totalRows>0">Check All &nbsp;<input type="checkbox"  @click='checkAll()' v-model='isCheckAll' ></div>
                        </b-col>
                        <!-- <b-col md="2">
                            <b-button v-if="CheckLoadID.length>0" @click="extendValidity()" size="md" variant="primary">Extend EBN Validity</b-button>
                        </b-col> -->
                        <b-col md="8" class="text-right">
                            <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
                        </b-col>
                    </b-row>
                    
                </div>

                <b-table show-empty responsive :busy="isBusy" :current-page="currentPage" :items="EBN_extendValidityItems" :fields="fields"  :bordered="bordered" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" style="overflow-x: auto !important;"> 
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div> 

                    <template slot="select" slot-scope="row">
                        <input class="shipmentscheckbox" type="checkbox"  v-bind:value="row.item.invoiceno"  v-model='CheckLoadID' @change="multiselectdesign($event)"/>
                    </template>
                </b-table>

                <paginate class="pt-2" 
                    v-model='pageNum'
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :current-page="currentPage">
                </paginate>

                <b-modal size="xl" title="Extension History" v-model="exHistoryModal" hide-footer>
                    <b-row>
                        <b-col sm="12" class="text-right">
                            <p > <b>Total Records :<span style="color:red;">{{ totalRowsCount }}</span></b> </p>
                        </b-col>
                        <b-col sm="12">
                            <b-table
                            show-empty 
                            responsive 
                            :items="exHistoryItems" 
                            :busy="isBusy1" 
                            :current-page="currentPage1"
                            :fields="historyFields" 
                            :bordered="bordered"
                            :filter="filter"   
                            :sort-by.sync="sortBy"  
                            :sort-desc.sync="sortDesc"   
                            :sort-direction="sortDirection"  
                            @filtered="onFiltered"
                            >

                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>

                                <template slot="ewb_download" slot-scope="row" v-if="row.item.request_status=='Success'">
                                    <!-- <b-button variant="primary"  @click="downloadEwayBill(row.item)" >
                                        Download
                                    </b-button>        -->

                                    <p style="text-align: center; color:#488dfa">
                                        <i class="fa fa-download" @click="downloadEwayBill(row.item)"></i>
                                    </p>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-modal>

                <b-modal size="lg" title="Extension History" v-model="exResponseModal" hide-footer hide-header>
                    <div>
                        <h5 style="color: red;" class="responsive-text">{{ extensionResponse.returnvalue }}</h5>  
                        <h6 class="responsive-text" ><b>Extension Request Pending : </b>{{ extensionResponse.extension_request_pending }}</h6> 
                        <h6 class="responsive-text" ><b>Extension Request Success : </b>{{ extensionResponse.extension_request_success }}</h6> 
                        <h6 class="responsive-text" ><b>Extension Request Failed : </b>{{ extensionResponse.extension_request_failure }}</h6>
                        <div class="text-center mt-4">
                            <b-button @click="closeResponseModal" size="md" variant="secondary">Ok</b-button>   
                        </div>              
                    </div>
                </b-modal>
            </b-col>
        </b-row>
    </ENB_Extend_Validity>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            isBusy: false, 
            searching :[],
            searchvaluesarr:[],
            route_id : null,
            bordered : true,
            fields :[],
            normalFields:[
                { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
                { key: 'parentawb', label : 'Parent AWB', sortable: true},
                { key: 'invoiceno', label : 'Load ID', sortable: true},
                { key: 'gstinno', label : 'GST No', sortable: true},
                { key: 'ebn', label : 'EBN', sortable: true},
                { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
                { key: 'extend_error_msg', label : 'EBN Error', sortable: true},
                { key: 'sellergstregnumber', label : 'Seller GST No.', sortable: true},
                { key: 'sourcecity', label : 'Source City', sortable: true},
                { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
                { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
                { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                // { key: 'error', label : 'Error', sortable: true},              
            ],
            asnFields:[
                { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
                { key: 'parentawb', label : 'Parent AWB', sortable: true},
                { key: 'invoiceno', label : 'Load ID', sortable: true},
                { key: 'gstinno', label : 'GST No', sortable: true},
                { key: 'ebn', label : 'EBN', sortable: true},
                { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
                { key: 'extend_error_msg', label : 'EBN Error', sortable: true},
                { key: 'buyergstregnumber', label : 'Buyer GST No.', sortable: true},
                { key: 'sourcecity', label : 'Source City', sortable: true},
                { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
                { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
                { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                // { key: 'error', label : 'Error', sortable: true},                 
            ],  

            EBN_extendValidityItems :[],
            totalRows: 0,
            noofpages:'',
            pageNum:1,
            currentPage:1,
            perPage:100,
            CheckLoadID :[],
            SelectLoadID :[],
            isCheckAll: false,

            //Extension History Modal
            exHistoryModal : false,
            isBusy1: false,
            totalRowsCount : 0,
            noofpages1:'',
            pageNum1:1,
            currentPage1:1,
            perPage1:100,
            exHistoryItems:[],
            historyFields:[
                { key: 'parentawb', label: 'AWB No', sortable: true,},
                { key: 'invoiceno', label: 'Invoice No', sortable: true, },
                { key: 'ebn', label: 'EBN', sortable: true, },
                { key: 'extend_request_on', label: 'Extend Request On', sortable: true, },
                { key: 'extended_by', label: 'Extended By', sortable: true, },
                { key: 'extend_error_message', label: 'Extended Error', sortable: true,},
                { key: 'ebn_extended_on', label: 'Extended On', sortable: true, },
                { key: 'validity_till', label: 'Validity Till', sortable: true, },
                { key: 'request_status', label: 'Request Status', sortable: true, },
                { key: 'ewb_download', label: 'EWB Download' },
            ],

            // extension validity response modal
            exResponseModal:false,
            extensionResponse:[],
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.User_type = userInfo.user_type;
        this.route_id = this.$route.params.id;
        console.log("this.route_id",this.route_id)
        if (this.route_id=='normal') {
            this.fields=this.normalFields
        }else{
            this.fields=this.asnFields
        }
        this.accessBody = userInfo.body;
        console.log("--------->>>>>>>>>>",userInfo.body)
        this.ischeckbodyvalidation();
        // this.EBNExtendValidityRecords(this.pageNum);
    },

    methods:{
        ischeckbodyvalidation(){
      for (let i = 0; i < this.accessBody.length; i++) {
        const element = this.accessBody[i];
     
        if (element.title=='ENB Extension' && element.isReadonly==true && this.route_id=='normal') {
          this.isReadOnly=true
        }
       if (element.child) {
        for (let j = 0; j < element.child.length; j++) {
          const k = element.child[j];
           if (k.title=='ENB Extension' && k.isReadonly==true && this.route_id=='normal') {
            this.isReadOnly=true
          }
          if (k.title=='ENB Extension' && k.isReadonly==true && this.route_id=='asn') {
            this.isReadOnly=true
          }
         
        }
       }
      }
      console.log(" this.isReadOnly", this.isReadOnly)
    },
        checklength(value){
            if (value.length==0) {
                this.searching=[]
                this.totalRows=0
                this.searchvaluesarr=[]
                this.EBN_extendValidityItems=[];
                // this.EBNExtendValidityRecords(this.pageNum)
            }
        },

        EBNExtendValidityRecords : function(pageNo){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.isBusy=true;

            if(pageNo==1){
                this.EBN_extendValidityItems = [];
                this.pageNum=1;
                this.totalRows = 0;
                this.noofpages = 0;
            }
            const obj={
                pageno:`${pageNo}`,
                searchkey:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
                // is_asn: this.route_id=='normal' ? 'NO': 'YES',
            }

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/searchAwbDetailsForExtension`,obj)
            .then(result => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.EBN_extendValidityItems=result.body.returnvalue;
                    this.totalRows = result.body.totalcount;  
                    this.noofpages=parseInt(this.totalRows)/this.perPage;
                    this.noofpages=Math.ceil( this.noofpages);    
                }else{
                    this.EBN_extendValidityItems=[];
                    this.totalRows = 0;
                    this.noofpages = 0;
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "warning",
                        timer: 30000
                    });
                }
            }).catch(ex => {
                this.isBusy=false;
                console.log("error", ex);
            });
        },

        clickCallback(pageNum){
            this.isCheckAll=false;
            this.CheckLoadID = [];
            this.EBNExtendValidityRecords(pageNum);
        },

        downloadEBN_extendValidity(){
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                emailId:userInfo.sysemailid,
                searchkey:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
                // is_asn: this.route_id=='normal' ? 'NO': 'YES',
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/searchAwbDetailsForExtensionCSVDownload`,obj)
            .then(result => {
               document.getElementById("overlay").style.display = "none";
                if(result.body.returnmsg === "Successful"){
                    this.$fire({
                        text:"Please Check Your Mail For Downlod Link",
                        type: "success",
                        timer: 30000
                    });
                }
                else{
                    this.$fire({
                        text:"Can not Download",
                        type: "error",
                         timer: 30000
                   });
                }
            })
            .catch(ex => {
                console.log("error", ex);
            });
        },

        getExtension_history(){
            this.exHistoryModal=true
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.isBusy1 = true;

            const obj={
                emailId:userInfo.sysemailid,
            }

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getExtensionHistoryRequestedByUser`,obj)
            .then(result => {
                this.isBusy1=false;
                if (result.body.returnmsg === "Successful") {
                    this.exHistoryItems=result.body.returnvalue;
                    this.totalRowsCount = result.body.returnvalue.length;  
                    // this.noofpages1=parseInt(this.totalRowsCount)/this.perPage1;
                    // this.noofpages1=Math.ceil( this.noofpages1);    
                }else{
                    this.exHistoryItems=[];
                    this.totalRowsCount = 0;
                    // this.noofpages1 = 0;
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "warning",
                        timer: 30000
                    });
                }
            }).catch(ex => {
                this.isBusy1=false;
                console.log("error", ex);
            });
        },

        downloadEwayBill(item){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
           // console.log("item-->",item)

            const obj={
                ebn : item.ebn,
                awb : item.parentawb
            }

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/downloadDirectEwayBillFromTaxilla`,obj)
            .then(result=>{
                let url = ''
                    
                if (result.body.returnmsg === "Successful") {
                    url = result.body.returnvalue
                    window.open(url)
                }else{
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "warning",
                        timer: 30000
                    });
                }         
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        extendValidity(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.exResponseModal = false;

            const obj={
                emailId:userInfo.sysemailid,
                loadids:this.CheckLoadID
            }

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/applyForExtensionForRequestedAwbs`,obj)
            .then(result => {
                if (result.body.returnmsg === "Successful") {
                    this.extensionResponse=result.body;
                    this.exResponseModal = true;
    
                }else{
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "warning",
                        timer: 30000
                    });
                }
            }).catch(ex => {
                this.isBusy1=false;
                console.log("error", ex);
            });
        },

        closeResponseModal(){
            // alert("function called")
            this.exResponseModal = false;
        },

        searchEBN_extendValidity(){   
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
            var searchvalues=[];
            this.searchvaluesarr=[];
            this.CheckLoadID = [];
            this.isCheckAll = false;
            searchvalues = this.searching.split(/[\s,]+/)
            for (var i = 0; i < searchvalues.length; i++) {
                this.searchvaluesarr.push(`${searchvalues[i]}`)
            }
            console.log("searching values",this.searchvaluesarr)
            // this.pageNum = 1;
            this.EBNExtendValidityRecords(1)
        },

        clearEBN_extendValidity(){
            this.searching=[];
            this.searchvaluesarr=[];
            this.EBN_extendValidityItems=[];
            this.CheckLoadID = [];
            this.isCheckAll = false;
            this.totalRows=0;
            this.noofpages=0;
           // this.EBNExpiryRecords(this.pageNum)
        },

        multiselectdesign(e){ 
            // console.log("this.EBN_extendValidityItems.length",this.EBN_extendValidityItems.length,this.CheckLoadID.length)        
            if(this.CheckLoadID.length != this.EBN_extendValidityItems.length){
                this.isCheckAll = false;
            }
            else{
                this.isCheckAll = true;
            }    
        //    this.isCheckAll = this.CheckLoadID.length === this.EBN_extendValidityItems.length; 
        },

        checkAll: function(){
            // console.log("this.EBN_extendValidityItems.length",this.EBN_extendValidityItems.length,this.CheckLoadID.length)    
            this.isCheckAll = !this.isCheckAll;
            this.CheckLoadID = [];
            if(this.isCheckAll){ // Check all
                for (var key in this.EBN_extendValidityItems) {
                    this.CheckLoadID.push(this.EBN_extendValidityItems[key].invoiceno);
                }
                
            }
        },
    }
}    

</script>

<style scoped>
    .responsive-text {
        word-wrap: break-word;
        word-break: break-word; 
    }
</style>